var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "cancel-blue_svg__b",
    width: "107.8%",
    height: "108.9%",
    x: "-3.9%",
    y: "-4.2%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "cancel-blue_svg__d",
    width: "101.7%",
    height: "107.6%",
    x: "-.9%",
    y: "-3.4%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "cancel-blue_svg__a",
    d: "M182 191h1180c5.523 0 10 4.477 10 10v1020c0 5.523-4.477 10-10 10H182c-5.523 0-10-4.477-10-10V201c0-5.523 4.477-10 10-10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cancel-blue_svg__e",
    d: "M0 5c0-2.762 2.233-5 4.995-5h1100.01A5.003 5.003 0 011110 5v241c0 2.762-2.233 5-4.995 5H4.995A5.003 5.003 0 010 246V5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-1100 -448)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M0 0h1545v3046H0z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "cancel-blue_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cancel-blue_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#cancel-blue_svg__b)",
    xlinkHref: "#cancel-blue_svg__a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#cancel-blue_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#cancel-blue_svg__c)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(232 271)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#cancel-blue_svg__d)",
    xlinkHref: "#cancel-blue_svg__e"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#cancel-blue_svg__e"
  }))), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    mask: "url(#cancel-blue_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#008CFF",
    strokeLinejoin: "round",
    d: "M1119.548 454.4c.636 0 1.152.516 1.152 1.152v1.908h0a2.041 2.041 0 100 4.08v1.908c0 .636-.516 1.152-1.152 1.152h-16.096a1.152 1.152 0 01-1.152-1.152v-1.908h0a2.041 2.041 0 100-4.08v-1.908c0-.636.516-1.152 1.152-1.152h16.096zm-12.648 3.4h4.6m-4.6 3.4h9.2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 1.15,
    d: "M1100.575 467.433l20.7-15.866"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#008CFF",
    d: "M1101.725 467.433l20.7-15.866"
  })))));
}
export default SvgCancelBlue;